<template>
    <a-card>
      
      <h3 style="text-align: center;margin:20px 0 40px">项目负责人信息</h3>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #leaderType="{text}">
                <dict-render :dict-obj="dictObjs['leaderType']" :text="text"></dict-render>
            </template>
            <template #academicDegree="{text}">
                <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
            </template>
                <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddProjectLeader ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
  </template>
  
  <script>
  import store from '@/store';
  import AddProjectLeader from "./components/AddProjectLeader";
  import {tableListMixin,dictMixin} from "@/mixins";
  import {projectLeader} from "@/api/TechnologieprojekteApply";
import DictRender from "@/components/other/DictRender";
  
  const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "项目负责人类型", dataIndex: "leaderType", key: "leaderType", slots: {customRender: "leaderType"}},
    {title: "姓名", dataIndex: "name", key: "name"},
    {title: "学位（最高学历学位）", dataIndex: "academicDegree", key: "academicDegree", slots: {customRender: "academicDegree"}},
    {title: "工作单位", dataIndex: "workUnit", key: "workUnit"},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
  ];
  export default {
    name: "项目负责人信息",
    mixins: [tableListMixin,dictMixin],
    components: {
        DictRender,
        AddProjectLeader
    },
    data() {
        return {
            dictNames: 'leaderType,education_background',
            columns,
            queryParam: {projectId: store.getters.TechnologieTypeId.projectId,classification: store.getters.TechnologieTypeId.classification},
            listUrl: projectLeader.pageList,
            listKeyField: "id",
            deleteUrl: projectLeader.remove
        }
    },
    methods: {
        onAdd() {
            this.$refs.modal.postForm(store.getters.TechnologieTypeId.projectId,store.getters.TechnologieTypeId.classification)
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: projectLeader.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  